/* //global dataLayer */

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'gtm_push';
import { PAGE_VARS, PageKind } from '../../page/vars.js';

// Local imports
//
import { GaEventMutator } from './ga_event_mutator.js';

export let global_vars = {};

export function push_product_impressions(global) {
    if (global.productImpressions && global.productImpressions.length > 0) {
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                items: global.productImpressions,
            },
        });
        // Reset the value
        global.productImpressions = [];
    }

    if (global.promotions && global.promotions.length > 0) {
        window.dataLayer.push({
            event: 'view_promotion',
            ecommerce: {
                items: global.promotions,
            },
        });
        // Reset the value
        global.promotions = [];
    }
    push_ua_product_impressions(global);
}

export function push_ua_product_impressions(global) {
    // Send UA events
    if (
        (global.uaProductImpressions &&
            global.uaProductImpressions.length > 0) ||
        (global.uaPromotions && global.uaPromotions.length > 0)
    ) {
        window.dataLayer.push({
            event: 'productImpressions',
            ecommerce: {
                currencyCode: 'CAD',
                impressions: global.uaProductImpressions,
                promoView: {
                    promotions: global.uaPromotions,
                },
            },
        });

        // Reset the value
        global.uaProductImpressions = [];
        global.uaPromotions = [];
    }
}

function push_product_views(global) {
    if (global.productViews && global.productViews.length > 0) {
        window.dataLayer.push({
            event: 'view_item',
            ecommerce: {
                items: global.productViews,
            },
        });
        // Reset the value
        global.productViews = [];
    }
    push_ua_product_views(global);
}

function push_ua_product_views(global) {
    // Push UA events
    if (global.uaProductViews && global.uaProductViews.length > 0) {
        window.dataLayer.push({
            event: 'productView',
            detail: {
                ecommerce: {
                    products: global.uaProductViews,
                },
            },
        });
        // Reset the value
        global.uaProductViews = [];
    }
}

// Simply pushes a data object to the gtm
export function push_data_object(data) {
    // Convert events
    let eventMutator = new GaEventMutator();
    eventMutator.mutate(data).then(() => {
        setTimeout(() => {
            window.dataLayer.push(data);
        }, 1000);
    });
}

// Initialize module
export function initialize(global) {
    if (PAGE_VARS.kind !== PageKind.GiftCatalogue) {
        push_product_impressions(global);
        push_product_views(global);
    } else {
        push_ua_product_impressions(global);
        push_ua_product_views(global);
    }
}
